import { aes_decrypt, decodeJWTPayload } from "../helpers/helpers";
import axios from "../libs/axios";
import socket from "./socket";
import { modals } from "@mantine/modals";
import { Text } from "@mantine/core";
import { actions, store } from "../store/useStore";

// const accessToken = Cookies.get("session");
// const activeDevice = sessionState().active_device;
const _authState = store.auth.state();
// const setPermissions = getAuthPermissionState().setPermissions;

window.addEventListener("roleSwitched", async () => {
  // window.location.reload();
});

socket.on("permission_updated", async (data) => {
  const payload = decodeJWTPayload(_authState.authToken ?? "");
  // console.log("Event User Identifier", data?.receiverInfo?.identifier);
  // console.log("Payload User Identifier", payload.data.identifier);

  if (payload.data.identifier === data?.receiverInfo?.identifier) {
    const permissions = await axios.get("account/profile", {
      headers: {
        "fi-device-number": _authState.activeDeviceIdentifier ?? "",
        Authorization: `Bearer ${_authState.authToken}`,
      },
    });

    const decrypt = aes_decrypt({
      data: permissions?.data?.data?.userAuthoritiesInfo,
    });

    // TODO: Configure new permission based on the new store
    // setPermissions(JSON.parse(decrypt));
  }
});

socket.on("accessRevoked", async () => {
  // console.log("<<< accessRevoked >>>");
  // getAuthState().setUser(null);
  // getAuthState().setIsLoggedIn(false);
  // roleState().setActiveRole(null);
  // roleState().setRoles(null);
  // sessionState().setActiveDevice("");
  // Cookies.remove("session");
  // Cookies.remove("refresh-token");

  actions.auth.logout();
  // window.location.href = "/signin";
});

socket.on("ozonetelIncomingCall", (data: any) => {
  if (data?.lead_identifier) {
    modals.openConfirmModal({
      title: "Incoming Call",
      closeOnClickOutside: false,
      withCloseButton: false,
      centered: true,
      children: (
        <>
          <Text>
            <b> Name</b> : {data?.first_name || ""} {data?.last_name || ""}
          </Text>
          <Text>
            <b>Phone Number</b> : {data?.caller_id || ""}
          </Text>
        </>
      ),

      labels: {
        cancel: "Cancel",
        confirm: "View Details",
      },
      onConfirm: () => {
        window.location.href = `/leads?search=${data.lead_identifier}`;
      },

      onCancel: () => {
        modals.closeAll();
      },
    });
  }
});

export {};
